export default {
    topWindow: {
        seriesS: 'Series-S',
        support: 'Support',
        contact: 'Contact Us'
    },
    footWindow: {
        seriesS: 'Series-S',
        support: 'Support',
        contact: 'Contact Us',
        about: 'About Us',
        understand: 'Primeforce',
    },
    home: {
        s_arrived: 'The S-series multi-ply cutter.',
        power: 'Super powerful。',
        buy: 'buy',
        learnMore: 'Learn more'
    },
    series: {
        delight: 'From Desire to Delight',
        power: 'Pure power.',
        power_text1: 'Powered by revolutionary EVOLUTION System.',
        power_text2: 'Featuring On-the-Fly Cutting and Intelligent Cutting Correction (ICC).',
        power_text3: 'Redefining cutting quality and efficiency with disruptive upgrades. ',
        power_text4: '6,000 Strokes/m Vibrating Head for ultra-fast, rock-steady operation. ',
        power_text5: 'Million-cycle Proven Steel Tub withstands -25kPa vacuum.',
        power_text6: 'Concealed Silencer Design maximizes workspace accessibility.',
        power_text7: 'Where Raw Power Meets Uncompromised Innovation.',
        punching: 'Single Driller',
        double_punching: 'Double Driller',
        two_height: '2 Heights',
        MaxCuttingThickness: 'Max Cutting Thickness',
        threeWidth: '3 Widths',
        maxCuttingWidth: 'Max cutting width',
        twoLength: 'Dual Cutting Capacities.',
        twoKnife: 'Cutting Knives',
        cuttingRoom: 'Why settle for a cutting room',
        chimney: 'with a “CHIMNEY”?',
        concealed: 'PrimeForce',
        misChimney: 'Concealed Exhaust',
        chimney_right_text1: 'Strengthen the integrity of the framework ',
        chimney_right_text2: 'structure. Clean-sight cutting inspection',
        chimney_right_text3: 'and material collection.',
        unbreakable: 'Unbreakable',
        tank: 'Built Tub Like a Battle Tank ',
        tank_desc: '1 Million Pressure Cycles ',
        tank_desc1: 'Zero weld fractures or deformations',
        tank_desc2: 'Backed by 17 years of designing and manufacturing',
        tank_desc3: 'cutter for global premium brands,',
        tank_desc4: 'we’ve created this monolithic tank-grade tub.',
        heatwave: 'Heatwave?',
        battleReady: '24/7 Battle-Ready',
        heat_desc: 'PrimeForce TubeCooling The Invisible Cooling Beast',
        heat_desc1: '0.75kw Structural Air Tunnels Cooling,',
        heat_desc2: 'Industrial-grade forced air chilling.',
        heat_desc3: 'Hidden Duct Architecture, ',
        heat_desc4: 'zero visible vents, 100% clean lines.',
        galaxy_desc1: 'Weak vacuum due to leaking？',
        galaxy_desc2: 'Bring It On.',
        galaxy_desc3: 'Galaxy Mars 50/55',
        galaxy_desc4: 'Multi-stages Vacuum Pump. The Multistage ',
        galaxy_desc5: 'Vacuum Champion Multi-Patented Centrifugal Design. ',
        galaxy_desc6: 'The secret weapon of global premium brands.',
        galaxy_desc7: 'Unshakable Reliability,',
        galaxy_desc8: '24/7 operation under brutal conditions High-Flow Vacuum Lock, ',
        galaxy_desc9: 'Maintains grip even with cutting leaks.',
        vacuum: 'Vacuum MAX',
        match_vacuum: 'Mix & Match motor/blower configurations \n' +
            'to exceed any cutting challenges.\n',
        motor: 'Motor',
        saturn: 'Single-Stage High-Speed Centrifugal Vacuum Pump',
        saturn_desc1: 'Multiple Power Options',
        saturn_desc2: 'High-Speed PMSM',
        saturn_desc3: 'Up to 24,000 rpm',
        saturn_desc4: 'Vacuum to -25 kpa',
        saturn_desc5: 'Maglev PM High-Speed Motor',
        saturn_desc6: 'Up to 200,000 rpm',
        saturn_desc7: 'Vacuum to -40 kpa',
        saturn_desc8: 'Nebula Central Vacuum System',
        saturn_desc9: 'Precision-engineered for specific processes and the demands of large-scale manufacturing plants, our',
        saturn_desc10: 'system eliminates the need for overlay film by delivering a permanent and constant vacuum. Even ',
        saturn_desc11: 'filter clogging no longer compromises vacuum integrity. It\'s a safer, greener solution that pays for ',
        saturn_desc12: 'itself: the energy savings can cover the cost of a ',
        saturn_desc13: 'new cutting bed in just two years.\n',
        max_flow: 'Max Flow',
        max_vacuum: 'Max Vacuum',
        Competitor: 'Competitor’s',
        max_flow_vacuum: 'Vacuum @ Max Flow',
        clogged_filter: 'Clogged filter\n' +
            'killing productivity?',
        try_me: 'Try us and feel the difference.',
        vacuum_desc1: 'Patented cyclone + cartridge design ',
        vacuum_desc2: 'with cleaning indicator',
        vacuum_desc3: 'Dramatically reduces the impact of filter clogging',
        vacuum_desc4: 'on vacuum suction. Much Longer clean Cycles.',
        extendedCleaning: 'Extended cleaning cycle',
        impactFilterClogging: 'Impact of filter clogging',
        clogging_other: 'Competitor’s',
        sandingBelts: 'What are the advantages of our sharpening system compared to sanding belts?',
        sharpTime: '0.7s',
        sharpTimeDesc: 'Lightning-Fast Blade Sharpening',
        sharpWidth: 'Blade-Width Detection,',
        sharpWidthDesc: 'Takes Cutting Precision to the Next Level.',
        sharpBelts: 'Grinding Wheels Deliver',
        sharpBeltsDesc: 'Straighter Edges Than Belts.',
        sharpKnife: 'Razor-Sharp Edge.',
        sharpKnifeDesc: 'Reinforced Knife Back.',
        vibration: 'PrimeForce Vibration Unit\n',
        vibration_fast: 'Think You Know Fast? \n' +
            'Think Again.',
        vibration_rpm: '6000 rpm',
        vibration_desc: 'Rotating components balanced to ISO G2.5 standard, \n' +
            'enabling complete elimination of first-order vibration \n' +
            'in the S-Series vibrating head.\n',
        evolution_system: 'That powerful.',
        evolution_try: 'Yours to experience.',
        evolution_desc1: 'The S-Series Cutting Machine',
        evolution_desc2: 'Cutting Machine features the most advanced',
        evolution_desc3: 'cutting operating system to date.',
        evolution_desc4: 'CHN Copyright # 2025SR0494189',
        evolution_desc5: 'Smarter Cuts,',
        evolution_desc6: 'Safer Work, ',
        evolution_desc7: 'Faster Results.',
        fly_cutting: 'Cut While Moving, ',
        fly_cutting2: 'Move While Cutting.',
        fly_cutting3: 'Redefining Cutting Efficiency Through Seamless Continuous cutting',
        fly_cutting4: 'Blazing Fast',
        fly_cutting7: '1.3X Faster',
        banner_one_text1: 'Flawless Top-to-Bottom,',
        banner_one_text2: 'Cutting with',
        banner_one_text3: 'Supreme Performance.',
        banner_one_text4: 'S Cutter Powered by',
        banner_one_text5: 'Ensures perfect vertical cutting alignment',
        banner_one_text6: 'in multi-layer operations.',
        banner_second_text1: 'Auto-Symmetry Cutting Technology',
        banner_second_text2: 'Intelligently recognizes deep-V & symmetrical patterns.',
        banner_second_text3: 'Automated precision cutting with perfect mirror alignment.',
        banner_second_text4: 'Zero material damage, effortless symmetry guaranteed.',
        banner_three_text1: 'Micro-Gap Cutting',
        banner_three_text2: 'Effortless Precision',
        banner_three_text3: 'PrimeForce \n' +
            'Intelligent Blade Force Control Technology',
        banner_three_text4: 'Blade Force Control off',
        banner_three_text5: 'Blade Force Control on',
        banner_four_text1: 'Tiny Parts,Big Headaches? ',
        banner_four_text2: 'Not Anymore!',
        banner_four_text3: 'PrimeForce Small Pieces First Technology',
        banner_four_text4: 'Auto-Sequence Optimization.',
        banner_four_text5: 'Smart Cutting Path Planning.',
        banner_four_text6: 'Intelligent entry/exit points.',
        banner_four_text7: 'Collision-Free Guarantee.',
        banner_four_text8: 'Zero damage to adjacent pieces.',
        banner_five_text1: 'Fast When Needed, ',
        banner_five_text2: 'Slow When Required,',
        banner_five_text3: 'Flawless Precision.',
        banner_five_text4: 'PrimeForce EVO Cutting System',
        banner_five_text5: 'Equipped with Proximity SmartSpee Technology',
        banner_five_text6: 'Adjacent-Piece Deceleration.',
        banner_five_text7: 'Automatically reduces speed near Neighboring cuts.',
        banner_five_text8: 'Intelligent speed adaptation for flawless results.',
        banner_six_text1: 'Breakpoint Continuation Technology,',
        banner_six_text2: 'At the breakpoint,',
        banner_six_text3: 'continue to cut.',
        banner_six_text4: 'Pause anytime, resume perfectly,',
        banner_six_text5: 'No wasted cuts, no material loss.',
        malfunction_text1: 'Problem？',
        malfunction_text2: 'Here’s how to fix it.',
        malfunction_text3: 'Keep Cool,',
        malfunction_text4: 'Follow the on-screen wizard,',
        malfunction_text5: 'Apply the quick solutions,',
        malfunction_text6: 'Be your own repair expert!',
        maintenance_text1: 'Maintenance?',
        optional_title: 'Options & Accessories',
        optional_title2: 'Pick Any. Solve All.',
        SingleDrill: 'Single Drill',
        DualDrill: 'Dual Drill',
        SmartFeedingSystem: 'SmartFeeding Assistance System',
        CenteringTracker: 'Centering Tracker',
        SaasAccess: 'SaaS Access',
        KnifeCooling: 'Knife Cooling',
        Pre_Film: 'Pre-Film Mounting Bracket pro',
        Secondary: 'Secondary Film Covering',
        Vacuum: 'Heavy-Duty Vacuum Series',
        Scanner: 'Scanner',
        BrokenKnife: 'Broken Knife Detection',
        Floating: 'Floating bowl',
        Relocating: 'Auto Relocating',
        knife_desc: 'Floating bowl,',
        knife_desc1: 'Unrivaled \n in the Industry.',
        knife_desc2: 'S Cutter',
        knife_desc3: 'Optional Floating Bowl',
        knife_desc4: 'Auto-Adjusting Suspension Height.',
        knife_desc5: 'Prevents Top-Layer Fabric ',
        knife_desc6: 'Disturbance.',
        knife_desc7: 'Eliminates Static Generation.',
        knife_desc8: 'Where the bowl never touches,',
        knife_desc9: 'Yet always delivers.',
        recoating_desc1: 'Secondary film covering？ \n Available.',
        recoating_desc2: 'PrimeForce Optional Secondary film covering System.',
        recoating_desc3: 'Automatic Film Lifting when crossing windows.',
        recoating_desc4: 'Zero manual intervention.',
        recoating_desc5: 'High-speed cutting with vacuum-sealed.',
        recoating_desc6: 'Why choose between speed and perfection?',
        recoating_desc7: 'With S Cutter, you dominate both.',
        barcode_scanner: 'Scanner？Available.',
        barcode_scanner2: '(Optional Upgrade)',
        power_supply: 'Power supply and working environment',
        Dimensions: 'Dimensions',
        products_one_desc1: 'S6 Cutter',
        products_one_desc2: 'Precision',
        products_one_desc3: 'Max cutting thickness',
        products_one_desc4: 'Cutting Area Length',
        products_one_desc5: 'knife',
        products_one_desc6: '(Upgradeable)',
        products_one_desc7: 'Standard',
        products_one_desc8: 'S9 Cutter',
        products_one_desc9: 'Balance',
        products_one_desc10: 'S9 MAX Cutter',
        products_one_desc11: 'Productive',
        bed_data_desc1: 'Max Cutting Speed',
        bed_data_desc2: 'Max Frequency',
        bed_data_desc3: '11 kWh \n Average Energy Consumption',
        bed_data_desc4: 'Standard Process',
        bed_data_desc5: 'Worktable Height (Adjustable)',
        bed_data_desc6: '3700 kg Weight',
        bed_data_desc7: '(1818)',
        new: 'New face,',
        old: 'old souls.',
        contact_one: 'C2, Huaping (Changzhou) Intelligent MFG Park,\n',
        contact_two: 'Xinbei District, Changzhou, Jiangsu, China 213000 ',
    }
}
